import axios from "axios";
import axiosAuth from "./AxiosInstance";
import publicAxios from "./PublicAxiosInstance";
import Helper from '../Utils/Helper';
export class BreathAPIs {
  static baseUrl = process.env.REACT_APP_API_URL;
  static awsUrl = process.env.REACT_APP_AWS_LAMBDA_URL;
  static environment = process.env.REACT_APP_ENV;
  static async registerUser(userData) {
    const res = await axios.post(`${this.baseUrl}/api/registration`, userData, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async loginUser(userData) {
    const res = await axios.post(`${this.baseUrl}/api/login`, userData, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async BEVUserLogin(userData) {
    const res = await axios.post(
      `${this.baseUrl}/api/login/BEVUserLogin`,
      userData,
      {
        "Content-Type": "application/json",
      }
    );
    return res;
  }

  static async guestSendOTP(email, phone) {
    const res = await axios.post(`${this.baseUrl}/oauth/guest/send-otp`, { email, phone }, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async guestVerifyOTP(OTP, token) {
    const res = await axios.post(`${this.baseUrl}/oauth/guest/verify-otp`, { OTP, token }, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async getGuestSettings() {
    const res = await axios.get(`${this.baseUrl}/oauth/guest/settings`);
    return res;
  }

  static async guestLoginDirect(email, phone) {
    const res = await axios.post(`${this.baseUrl}/oauth/guest/login-direct`, { email, phone }, {
      "Content-Type": "application/json",
    });
    return res;
  }

  // Public (pre-login) progressive state -> city -> location lookup. No args
  // returns {states}, a state returns {cities}, state+city returns the
  // actual matching location docs (with charger counts).
  static async getPublicGuestLocations(state, city) {
    const params = {};
    if (state) params.state = state;
    if (city) params.city = city;
    const res = await axios.get(`${this.baseUrl}/oauth/guest/locations`, { params });
    return res;
  }

  static async getCustomerUsers(page = 1, limit = 10, filterText = null,filterLocation=null) {
    console.log("page, limit in getCustomerUsers", page, limit);
    console.log('filterLocation: ',filterLocation)
    const res = await axiosAuth.get("/api/user/getUserForCustomerLocation", {
      params: {
        page,
        limit,
        filterText,
        filterLocation
      },
    });
    return res;
  }

  static async addSoftwareVersion(softwareVersionData){
    const res = await axiosAuth.post(`/api/softwareVersion/addSoftwareVersion`, softwareVersionData, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async getSoftwareVersionList(page = 1, limit = 10, softwareType = null) {
    const res = await axios.get(`${this.baseUrl}/api/softwareVersion/getSoftwareVersionList`, {
      params: {
        page,
        limit,
        softwareType
      },
    });
    return res;
  }

  static async updateSoftwareVersion(id, softwareVersionData){
    const res = await axiosAuth.put(`/api/softwareVersion/updateSoftwareVersion/${id}`, softwareVersionData, {
      "Content-Type": "application/json",
    });
    return res;
  }

  static async deleteSoftwareVersion(id){
    const res = await axiosAuth.delete(`/api/softwareVersion/deleteSoftwareVersion/${id}`);
    return res;
  }

  static async getPublicSoftwareVersionList(softwareType, page = 1, limit = 5) {
    const res = await publicAxios.get(`/api/public-ctep-version-disclosure-h4k9x2mq7z/software`, {
      params: {
        softwareType,
        page,
        limit
      },
    });
    return res;
  }

  static async getPublicChargerFirmwareList(page = 1, limit = 5, serial = null) {
    const res = await publicAxios.get(`/api/public-ctep-version-disclosure-h4k9x2mq7z/charger-firmware`, {
      params: {
        page,
        limit,
        serial
      },
    });
    return res;
  }

  static async checkOverNightEnabledInPublic(){
    const res = await axiosAuth.get("/api/location/checkOvernightEnabledInPublic");
    return res;
  }

  static async checkShowRfidRegUI(){
    const res = await axiosAuth.get('/api/user/checkShowRfidRegUI');
    return res;
  }

  static async editCusotmerUser(userId, locationId) {
    try {
      const res = await axiosAuth.post(
        "/api/user/deleteUserLocation",
        { userId: userId, locationIds: [locationId] },
        {
          "Content-Type": "application/json",
        }
      );
      return res;
    } catch (error) {
      console.log("Error in editing customer user", error.message);
    }
  }

  static async addUsersToCustomerLocation(users, locations) {
    const res = await axiosAuth.post(
      "/api/user/addUserToCustomerLocation",
      {
        users: users,
        locations: locations,
      },
      {
        "Content-Type": "application/json",
      }
    );
    return res;
  }

  static async searchUserToAdd(email) {
    const res = await axiosAuth.get("/api/user/getUserByEmail", {
      params: {
        email: email,
      },
    });

    return res;
  }

  static async updateProfile(userData) {
    console.log(userData);
    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axiosAuth.post(`/api/user/update`, userData, headers);
    return res;
  }

    static async updateFavoriteLocation(locationID){
        const res = await axiosAuth.post(`/api/user/updateFavoriteLocation`, {locationID})
        return res;
    }

    static async updatePhone(phone){
        const res = await axiosAuth.post('/api/user/updatePhone',
            {
                phone: phone
            },
            {
                headers:{
                    'Content-Type': 'application/json'
                }
            }
        )

        return res;
    }

    static async checkIfPhoneUnique(phone){
        const res = await axiosAuth.post('/api/user/checkPhoneUnique',
            {
                phone: phone
            },
            {
                headers:{
                    'Content-Type': 'application/json'
                }
            }
        )

        return res;
    }

    static async checkIfPhoneUniqueForRegistration(phone){
        const res = await axios.post(`${this.baseUrl}/api/registration/checkPhoneUniqueRegister`,
            {
                phone: phone
            },
            {
                headers:{
                    'Content-Type': 'application/json'
                }
            }
        )

        return res;
    }
    

    static async updateUser(userData, addSublocation = false) {
        const headers = {
            'Content-Type': 'application/json'
        };
        const res = await axios.post(`${this.baseUrl}/api/user/updateUser`, { ...userData, addSublocation }, headers)
        return res;
    }

  static async updateBEVMemberUserType(userData) {
    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axios.post(
      `${this.baseUrl}/api/BEVuser/updateBEVMemberUserType`,
      userData,
      headers
    );
    return res;
  }

  static async updateWallet(walletData) {
    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axios.post(
      `${this.baseUrl}/api/user/updateWallet`,
      walletData,
      headers
    );
    return res;
  }

  static async addAmountFromCard(amount, paymentId, jwt) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/wallet/addFromCard`,
        {
          paymentId: paymentId,
          amount: amount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in addAmount From Card API", error);
    }
  }

  

  static async updateLocation(locationData, chargerDynamicRate, notifyUsers, updateCommissioningDate) {
    // console.log("charger dynamic rate before posting to db.", chargerDynamicRate)

    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axios.post(
      `${this.baseUrl}/api/location/updateLocation`,
      { locationData: locationData, chargerDynamicRate: chargerDynamicRate, notifyUsers: notifyUsers, updateCommissioningDate: updateCommissioningDate },
      headers
    );
    return res;
  }

  static async updateCharger(chargerData) {
    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axios.patch(
      `${this.baseUrl}/api/charger/updateCharger`,
      chargerData,
      headers
    );
    return res;
  }

  static async getUser() {
    const res = await axios.get(`${this.baseUrl}/api/auth`);

    return res;
  }

  static async getSiteApproverList(){
    const res = await axios.get(`${this.baseUrl}/api/siteTracker/getSiteApproverList`);
    return res;
  }

  static async sendSiteForApproval(trackerID, selectedApproverList){
    const res = await axios.post(`${this.baseUrl}/api/siteTracker/sendSiteForApproval`, {
      trackerID,
      selectedApproverList
    })
    return res
  }

  static async getBidApproverList() {
    const res = await axios.get(`${this.baseUrl}/api/deals/getApproverList`);
    return res;
  }

  static async sendBidForApproval(bidID, selectedApproverList){
    const res = await axios.post(`${this.baseUrl}/api/deals/sendForApproval`, {
      bidID,
      selectedApproverList
    });
    return res;
  }

  static async uploadBidPdfChunked(pdfBlob) {
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    const base64 = btoa(binary);

    const CHUNK_SIZE = 500 * 1024; // 500KB per chunk
    const totalChunks = Math.ceil(base64.length / CHUNK_SIZE);
    const uploadId = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;

    for (let i = 0; i < totalChunks; i++) {
      const chunkData = base64.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      await axiosAuth.post(`${this.baseUrl}/api/deals/uploadBidPdfChunk`, {
        uploadId,
        chunkIndex: i,
        totalChunks,
        chunkData,
      });
    }

    return uploadId;
  }

  static async updateBidStatus(bidID, status, comments, dealID, pdfBlob = null) {
    let pdfUploadId = null;
    if (pdfBlob) {
      try {
         pdfUploadId = await BreathAPIs.uploadBidPdfChunked(pdfBlob);
      } catch (error) {
        console.error("Error uploading bid PDF chunks:", error);
      }
     
    }
    const res = await axiosAuth.post(`${this.baseUrl}/api/deals/updateBidStatus`, {
      bidID,
      status,
      comments: JSON.stringify(comments),
      dealID,
      pdfUploadId,
    });
    return res;
  }

  static async acceptBid(bidID, checked){
    const res = await axiosAuth.post(`${this.baseUrl}/api/deals/acceptBid`, {
      bidID,
      checked
    });
    return res;
  }

  static async fetchApprovePendingSites(current, pageSize, filters=null, searchQuery=""){
    const res = await axiosAuth.get(`${this.baseUrl}/api/siteTracker/fetchApprovePendingSites`, {
        params: { page: current, limit: pageSize, filters: filters, searchQuery: searchQuery },
      });
    return res
  }
  static async getSiteTrackerData(current, pageSize, filters = null, searchQuery=""){
    const res = await axiosAuth.get(`${this.baseUrl}/api/siteTracker/getTrackerData`, {
        params: { page: current, limit: pageSize, filters: filters, searchQuery: searchQuery },
      });
    return res
  }

  static async updateSiteTrackerData(siteData, Id, sectionChanged = null){
    const res = await axiosAuth.post(`${this.baseUrl}/api/siteTracker/updateTrackerData`, {trackerData: siteData, trackerID: Id, sectionChanged: sectionChanged});
    return res;
  }
  
  static async updatePaymentDate(bidID,paymentDate) {
    const res  = await axiosAuth.post(`${this.baseUrl}/api/deals/updatePaymentDate`, {
      bidID, 
      paymentDate
    });
    return res;
  }

  static async deleteUser(id, force) {
    const res = await axios.delete(
      `${this.baseUrl}/api/user/delete/${id}?force=${force}`
    );
    return res;
  }

  static async getChagers() {
    const res = await axios.get(`${this.baseUrl}/api/charger`);

    return res;
  }
  static async getCharger(id) {
    const res = await axiosAuth.get(`/api/charger/${id}`, {
      // params: {
      //     id
      // },
    });

    return res;
  }
  static async getAllChargersByLocation(locationId) {
    try {
      const res = await axiosAuth.post(
        `api/charger/location/getAllChargersByLocation/${locationId}`
      );
      return res;
    } catch (error) {
      console.log("Error in getting all chargers by location", error.message);
    }
  }

  static async getRfidLocationChargers(
    locationID
  ){
    const res = await axiosAuth.get(`/api/charger/getRfidLocationChargers/${locationID}`)
    return res
  }

  static async updateUserRfid(idTag, idTagName){
    const res = await axiosAuth.post(`/api/user/editIdTag`, {
      rfidTag: idTag,
      idTagName: idTagName
    })
    return res
  }

  static async deleteUserRfid(idTag){
    const res = await axiosAuth.post(`/api/user/removeIdTag`, {
      rfidTag: idTag
    })
    return res
  }

  static async updateRfidRegInCharger(rfidSelectedCharger, userID, type){ //setUser, removeUser

    const res = await axiosAuth.post(`/api/charger/setRfidRegUser`,{
      setUser: type === 'setUser' ? true : false, 
      chargerId: rfidSelectedCharger
    })

    return res;

  }
  static async getAllChargerByLocation(
    locationId
  ) {
    const res = await axiosAuth.post(`/api/charger/location/getAllChargersInLocation/${locationId}`);
    return res;
  } 
  static async getChargerByLocation(
    locationId,
    date,
    endMinute = null,
    endTime = null
  ) {
    const res = await axiosAuth.post(`/api/charger/location/${locationId}`, {
      date,
      endMinute,
      endTime,
    });
    return res;
  }

  static async getAvailableNightChargeConnectors(bookingStartTime, bookingEndTime, connectorList){
    console.log("connector list in api: ", connectorList)
    const res = await axiosAuth.post(`/api/charger/getAvailableNightChargeConnectors`, {
            bookingStartTime: bookingStartTime,
            bookingEndTime: bookingEndTime,
            connectorList: connectorList
        
  })
    return res;
  }

  static async getAvailableChargers(bookingId, locationId, startTime = null) {
    // console.log(bookingId,locationId)
    console.log("updatedStartTIme", startTime);
    const res = await axiosAuth.post(
      `/api/charger/availableChargers/booking/${bookingId}`,
      { locationId, startTime }
    );
    return res;
  }

  static async updateBookingCharger(bookingID, chargerID) {
    try {
      const res = await axiosAuth.post(`/api/booking/updateCharger`, {
        bookingID,
        chargerID,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createAutoPayNonResBooking(connector, startTime, timezone=null) {
    try {
      let chargerTime = Helper.convertToChargerTimeZone(new Date(startTime), timezone ) 
      let chargerTimeEnd = chargerTime
      let offSetBetweenChargerAndLocal = startTime ? startTime.getTime() - chargerTime.getTime() : 0
      console.log("chargerTime, chargerTimeEnd", chargerTime, chargerTimeEnd)
      let dayStart = chargerTime.setHours(0,0,0,0)
      let dayEnd = chargerTimeEnd.setHours(23, 59, 59, 999)
      dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
      dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)
      // let tempTime = new Date(startTime);
      // let dayStart = tempTime.setHours(0, 0, 0, 0);
      // let dayEnd = tempTime.setHours(23, 59, 59, 999);
      const res = await axiosAuth.post(`/api/booking/createAutoPayNonResBooking`, {connector, startTime, dayStart, dayEnd, bookingCreationSource: "webApp"});
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createNonResBooking(bookingData, bookingCreatedAt, guestPaymentIntentId = null) {
    try{
      const res = await axiosAuth.post(`/api/booking/createNonResBooking`,
        { bookingData: bookingData, bookingCreatedAt: bookingCreatedAt, guestPaymentIntentId }, {
      });
      return res;
    }catch(error){
      throw error;
    }

  }

  static async createSupport(values) {
    try {
      const res = await axiosAuth.post(`/api/booking/createSupport`, {
        values,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createSupportRefund(supportID) {
    const res = await axiosAuth.post(`/api/support/refundAmt`, { supportID });
    return res;
  }

  // static async getBookings(){
  //     const res = await axios.get(`${this.baseUrl}/api/booking`)
  //     return res;
  // }
  static async getBookingRefunds(
    startDate = null,
    endDate = null,
    locationID = null,
    selectedTimeZone
  ) {
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    // console.log("dates after update: ", startDate, endDate)

    let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const res = await axios.get(
      `${this.baseUrl}/api/dashboard/getBookingsRefundData`,
      {
        params: {
          locationID: locationID,
          startDate: startDate,
          endDate: endDate,
          StartUTCOffset: StartUTCOffset,
          EndUTCOffset: EndUTCOffset,
          selectedTimezone: selectedTimeZone,
          timezone: timezone,
        },
      }
    );
    return res;
  }

  static async getBookingsList({
    page = 1,
    limit = 10,
    filterEmail = null,
    filterLocation = null,
    filterFromDate = null,
    filterToDate = null,
    miscFeesValue = null,
    bookingStatus = null,
    isRefunded = false,
  }) {
    try {
      const res = await axios.get(`${this.baseUrl}/api/booking/list`, {
        params: {
          page,
          limit,
          filterEmail,
          filterLocation,
          filterFromDate,
          filterToDate,
          miscFeesValue,
          bookingStatus,
          isRefunded
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateBookingAdmin(bookingData, bookingUpdateCreatedAt) {
    const headers = {
      "Content-Type": "application/json",
    };
    const res = await axios.post(
      `${this.baseUrl}/api/booking/updateBookingAdmin`,
      {
        bookingData: bookingData,
        bookingUpdateCreatedAt: bookingUpdateCreatedAt,
      },
      headers
    );
    return res;
  }

  static async cancelBookingAdmin(id) {
    const res = await axios.delete(`${this.baseUrl}/api/booking/delete/${id}`);
    return res;
  }

  static async getBookingList(
    date,
    location,
    charger = null,
    connector = null
  ) {
    try {
      if (location != null) {
        // console.log('ssssssss', location)
        const response = await axiosAuth.post(
          `/api/booking/bookingList`,
          charger ? { date, location, charger, connector } : { date, location }
        );
        return response;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching booking list:", error);
      throw error;
    }
  }

  static async getUserGroups() {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getUserGroups`
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getAllBidDeals(current, pageSize, approverView, filters = {}, searchQuery="", dealsWithBidsFilter=0) {
    console.log("approverView in api call: ", approverView);
    try {
      const response = await axiosAuth.get(`${this.baseUrl}/api/deals/all`, {
        params: { page: current, limit: pageSize, approverView: approverView, filters: filters, searchQuery: searchQuery, dealsWithBidsFilter:dealsWithBidsFilter },
      });
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }
  


  static async getPendingBidDeals(current, pageSize, searchQuery="", dealsWithBidsFilter=0) {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/deals/pending`,
        { params: { page: current, limit: pageSize, searchQuery: searchQuery, dealsWithBidsFilter: dealsWithBidsFilter } }
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getAllLiveBidDeals(current, pageSize, forApprover, searchQuery="", dealsWithBidsFilter=0) {
    try{
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/deals/live`,
        { params: { page: current, limit: pageSize, forApprover: forApprover, searchQuery: searchQuery, dealsWithBidsFilter: dealsWithBidsFilter } }
      );
      return response;

    }catch (error){
      console.log(error.message);
      throw error;
    }
  }
  static async getDealBids(dealId, approverView) {
    // console.log("Approver view",approverView)
    try {
      const response = await axiosAuth.get(`${this.baseUrl}/api/deals/bids`, {
        params: { dealId: dealId , approverView: approverView},
      });
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async createBid(newBidData, selectedDealId) {
    try {
      const response = await axiosAuth.post(
        `${this.baseUrl}/api/deals/createBid`,
        {
          newBidData,
          selectedDealId,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  static async updateBid(newBidData, bidId) {
    const response = await axiosAuth.post(
      `${this.baseUrl}/api/deals/updateBid`,
      { newBidData, bidId }
    )
    return response;
  }
  static async syncData() {
    try {
      const response = await axiosAuth.post(
        `${this.baseUrl}/api/deals/syncData`, {}, { timeout: 180000 } // in ms
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async chargerLocker(chargerId, action) {
    try {
      const response = await axiosAuth.post(
        `${this.baseUrl}/api/charger/unlock`,
        {chargerId, action}
      );
      return response;
    } catch (error) {
      console.error("Error locking/unlocking connector:", error.message);
      throw error;
    }
  }

  static async getUserPermissions() {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getPermissions`
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getBookingHistory(page = 1, pageSize = 10, chargerID = null) {
    try {
      const res = await axiosAuth.get(
        `/api/booking/history?page=${page}&pageSize=${pageSize}${chargerID ? `&chargerID=${chargerID}` : ''}`
      );
      return res;
    } catch (error) {
      console.error("Error fetching booking history:", error.message);
      throw error;
    }
  }

  static async getLastSessionResponse(chargerIds, userID, startTime = null, endTime = null){
    const res = await axiosAuth.get(`/api/sessions/getLastSession`, {
      params:{
        chargerIds: chargerIds,
        userID: userID,
        startTime: startTime,
        endTime: endTime
      }
    });
    return res;
  }

  static async getUpcomingBookings() {
    const res = await axiosAuth.get(`/api/booking/upcoming`);
    return res;
  }

  static async getTotalFutureEstimate() {
    const res = await axiosAuth.get(`/api/booking/totalFutureEstimateAmount`);
    return res;
  }

  static async makeBooking(booking, bookingCreatedAt, guestPaymentIntentId = null) {
    const res = await axiosAuth.post(
      `/api/booking`,
      { booking: booking, bookingCreatedAt: bookingCreatedAt, guestPaymentIntentId },
      {
        "Content-Type": "application/json",
      }
    );
    return res;
  }

  static async updateBookingTime(
    bookingId,
    estimateAmount,
    timeDifferenceInSeconds,
    newFromDate,
    connector,
    startEarlyActionCreatedAt, 
    nightChargeEstimate
  ) {
    const res = await axiosAuth.post(`/api/booking/updateTime`, {
      bookingId,
      estimateAmount,
      timeDifferenceInSeconds,
      newFromDate,
      connector,
      startEarlyActionCreatedAt,
      nightChargeEstimate
    });
    return res;
  }

  static async extendBookingTime(
    bookingId,
    estimateAmount,
    timeDifferenceInSeconds,
    newEndTime,
    extendActionCreatedAt,
    isNightCharging,
    nightChargingEstimate,
    nightChargeEndLocalTZ
  ) {
    const res = await axiosAuth.post(`/api/booking/extendBookingTime`, {
      bookingId,
      estimateAmount,
      timeDifferenceInSeconds,
      newEndTime,
      extendActionCreatedAt,
      isNightCharging,
      nightChargingEstimate,
      nightChargeEndLocalTZ
    });
    return res;
  }

  static async cancelBooking(id) {
    const res = await axiosAuth.delete(`/api/booking/${id}`, {
      data: { bookingCancelCreatedAt: new Date() },
    });
    return res;
  }

  static async getBooking(id) {
    const res = await axios.get(`${this.baseUrl}/api/booking/${id}`);
    return res;
  }
  static async getBookingSession(id){
    const res = await axiosAuth.get(`${this.baseUrl}/api/booking/bookingSession/${id}`);
    return res;
  }

  static async getBilling(id) {
    const res = await axiosAuth.get(`/api/billing/show/${id}`);
    return res;
  }

  static async getBookingVersionHistory(id) {
    const res = await axiosAuth.get(`/api/booking/bookingVersionHistory/${id}`);
    return res;
  }

  static async getLocations() {
    const res = await axios.get(`${this.baseUrl}/api/location`);
    return res;
  }

  static async getRegistrationLocations() {
    const res = await axios.get(`${this.baseUrl}/api/registration/locations`);
    return res;
  }

  static async checkLocationCode(codeId, { includeRedirectCode = false } = {}) {
    const res = await axiosAuth.get(`/api/registration/check-code-id`, {
      params: { codeId, ...(includeRedirectCode ? { includeRedirectCode: true } : {}) },
    });
    return res;
  }

  static async addLocation(location) {
    const res = await axios.post(`${this.baseUrl}/api/location`, location);
    return res;
  }

  static async sendLocationChargerDetails(siteStatus,locationDetails,chargerDetails,rateDetails,hardwareDetails, notifyUsers = false){
    try {

      const res = await axiosAuth.post(`/api/siteTracker/sendLocationChargerDetails`,{siteStatus,locationDetails,chargerDetails,rateDetails,hardwareDetails, notifyUsers});
      return res;
      
    } catch (error) {
      console.log('Error while setting up location and charger data for site onboarding pre-live stage')
    }

  }

  static async deleteLocation(id) {
    const res = await axios.delete(`${this.baseUrl}/api/location/delete/${id}`);
    return res;
  }

  static async addCharger(charger) {
    const res = await axios.post(`${this.baseUrl}/api/charger`, charger);
    return res;
  }

  static async deleteCharger(id, force) {
    const res = await axios.delete(
      `${this.baseUrl}/api/charger/delete/${id}?force=${force}`
    );
    return res;
  }

  static async getLocationList({
    page = 1,
    limit = 10,
    filterLocationName = "",
    subLocationType = "",
  }) {
    try {
      const params = {
        page,
        limit,
      };

      if (filterLocationName) {
        params.filterLocationName = filterLocationName;
      }

      if (subLocationType) {
        params.subLocationType = subLocationType;
      }

      const res = await axios.get(`${this.baseUrl}/api/location/list`, {
        params,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getAllLocations() {
    try {
      const result = await axios.get(`${this.baseUrl}/api/location/getAll`);
      return result;
    } catch (error) {
      console.log("Error in getting all locations", error.message);
    }
  }

  static async getPublicLocations() {
    try {
      console.log("fetching public locations for map view.");
      const res = await axiosAuth.get(`/api/location/publicLocations`);
      console.log("getpublic location api response: ", res);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getGuestAccessibleLocations() {
    try {
      const res = await axiosAuth.get(`/api/location/guestAccessibleLocations`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getNearbyPublicLocations(latitude, longitude) {
    try {
      const res = await axiosAuth.get(
        `/api/location/nearbyPublicLocations?latitude=${latitude}&longitude=${longitude}`
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getMonthlyChargerAndUser(endDate, userFilterLocationIds=[]){
    try {
      if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
      const res = await axios.get(`${this.baseUrl}/api/dashboard/getMonthlyChargerAndUser`, 
        {
          params: {
            endDate: endDate,
            userFilterLocationIds: userFilterLocationIds,
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getLocation(location_id) {
    try {
      if (location_id) {
        const res = await axios.get(
          `${this.baseUrl}/api/location/${location_id}`
        );
        return res;
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  }

  static async getChargerMetric(
    chargerID,
    startDate = "",
    endDate = "",
    details = false
  ) {
    try {
      const params = { chargerID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (endDate) {
        params.endDate = endDate;
      }

      if (details) {
        params.details = details;
      }

      const res = await axios.get(`${this.baseUrl}/api/metric/ChargerData`, {
        params,
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getLocationMetric(
    locationID,
    startDate = "",
    endDate = "",
    details = false
  ) {
    try {
      const params = { locationID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (endDate) {
        params.endDate = endDate;
      }

      if (details) {
        params.details = details;
      }

      const res = await axios.get(`${this.baseUrl}/api/metric/LocationData`, {
        params,
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  //need to remove
  static async get24hrSessionUtilizationMetric(
    locationID,
    startDate = "",
    UTCOffset
  ) {
    try {
      const params = { locationID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (UTCOffset) {
        params.UTCOffset = UTCOffset;
      }

      const res = await axios.get(
        `${this.baseUrl}/api/metric/Location24hrSessionUtilisationData`,
        { params }
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getLocationFinancialData(
    locationID,
    startDate = "",
    endDate = ""
  ) {
    try {
      const params = { locationID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (endDate) {
        params.endDate = endDate;
      }

      const res = await axios.get(`${this.baseUrl}/api/metric/getProfitData`, {
        params,
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getLocationUtilizationData(
    locationID,
    startDate = "",
    endDate = "",
    isGraphResult
  ) {
    try {
      const params = { locationID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (endDate) {
        params.endDate = endDate;
      }

      if (isGraphResult) {
        params.isGraphResult = isGraphResult;
      }

      const res = await axios.get(
        `${this.baseUrl}/api/metric/getUtilizationData`,
        { params }
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getChargerUtilizationData(
    chargerID,
    startDate = "",
    endDate = "",
    isGraphResult
  ) {
    try {
      const params = { chargerID };

      if (startDate) {
        params.startDate = startDate;
      }

      if (endDate) {
        params.endDate = endDate;
      }

      if (isGraphResult) {
        params.isGraphResult = isGraphResult;
      }

      const res = await axios.get(
        `${this.baseUrl}/api/metric/getUtilizationData`,
        { params }
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getUserFinancialData(userID) {
    try {
      const params = { userID };

      const res = await axios.get(`${this.baseUrl}/api/metric/getProfitData`, {
        params,
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async deleteLogs() {
    try {
      const res = await axios.delete(`${this.baseUrl}/api/logs/deleteLogs`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async customerChargerList(location) {
    try {
      const params = { location };

      const res = await axios.get(`${this.baseUrl}/api/charger/customerChargerList`, {
        params: params,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateChargerRate(filterLocation, chargerDynamicRate, rateType, normalRate){
    console.log("api data: ", filterLocation, chargerDynamicRate, rateType, normalRate)
    try {
      

      const res = await axios.post(`${this.baseUrl}/api/location/rateUpdateCustomer`, {
        filterLocation,
        chargerDynamicRate,
        rateType,
        normalRate
      });

      return res;
    } catch (error) {
      throw error;
    }
    
  }

  static async resetCharger(csmsBreatheChargerID, resetType){
    try {
      const res = await axiosAuth.post(`/api/charger/resetCharger`, {
        csmsChargerId: csmsBreatheChargerID,
        resetType: resetType
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getChargerFirmware(locationId){
    try{
      console.log("lcoation id : ", locationId)
      const params = {
        location: locationId
      }
      const res = await axiosAuth.get(`/api/charger/getChargerFirmware`, {
        params: params,
      });
      return res
    }catch(err){
      console.log(err)
    }
  }
  static async getChargerList({ page = 1, limit = 10, location_id = null, chargerStatus=null,chargerAvailability=null,unlistCharger=null }) {
    console.log("locaiton id in api call", location_id);
    try {
      const params = {
        page,
        limit,
      };

      if (location_id) {
        params.location = location_id;
      }
      if(chargerStatus){
        params.chargerStatus = chargerStatus;
      }
      if(chargerAvailability){
        params.chargerAvailability = chargerAvailability;
      }
      if(unlistCharger){
        params.unlistCharger = unlistCharger;
      }

      const res = await axios.get(`${this.baseUrl}/api/charger/list`, {
        params: params,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getSupportTicketList({
    page = 1,
    limit = 10,
    filterEmail,
    filterFromDate,
    filterToDate,
    filterStatus,
  }) {
    try {
      const params = {
        page,
        limit,
      };

      if (filterEmail) {
        params.filterEmail = filterEmail;
      }

      if (filterFromDate) {
        params.filterFromDate = filterFromDate;
      }

      if (filterToDate) {
        params.filterToDate = filterToDate;
      }

      if (filterStatus) {
        params.filterStatus = filterStatus;
      }

      const res = await axios.get(`${this.baseUrl}/api/support/list`, {
        params: params,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getUserSupportTicketList({
    page = 1,
    limit = 10,
    filterFromDate,
    filterToDate,
    filterStatus,
  }) {
    try {
      const params = {
        page,
        limit,
      };

      if (filterFromDate) {
        params.filterFromDate = filterFromDate;
      }

      if (filterToDate) {
        params.filterToDate = filterToDate;
      }

      if (filterStatus) {
        params.filterStatus = filterStatus;
      }

      const res = await axios.get(
        `${this.baseUrl}/api/support/userSupportList`,
        {
          params: params,
        }
      );

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async bookingSupportList(id) {
    const res = await axios.get(
      `${this.baseUrl}/api/booking/bookingSupportList/${id}`
    );
    return res;
  }

  static async getUserList({ page = 1, limit = 10, filterText = "",filterLocation=null,filterWallet=null,filterUserType=null }) {
    try {
      const res = await axios.get(`${this.baseUrl}/api/user/list`, {
        params: {
          page,
          limit,
          filterText,
          filterLocation,
          filterWallet,
          filterUserType
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getGuestUserList({ page = 1, limit = 10, filterText = "" }) {
    try {
      const res = await axios.get(`${this.baseUrl}/api/user/guestList`, {
        params: {
          page,
          limit,
          filterText,
        },
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getSupport(id) {
    const res = await axiosAuth.get(`/api/support/${id}`, {});
    return res;
  }

  static async deleteSupportTicket(id) {
    try {
      const res = await axiosAuth.delete(`/api/support/${id}`, {});
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateSupport(values, id) {
    try {
      const res = await axiosAuth.post(`/api/support/updateSupport/${id}`, {
        values,
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async emailAddressVerification(token) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/verification/email`,
        { token }
      );
      return res;
    } catch (error) {
      console.error("Error during email verification:", error);
      throw error;
    }
  }

  static async reSendEmailVerification(email) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/verification/email`,
        { email }
      );
      return res;
    } catch (error) {
      console.error("Error during email verification:", error);
      throw error;
    }
  }

  static async send2FACode(email) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/admin2FAValidation`,
        { email }
      );
      return res;
    } catch (error) {
      console.error("Error 2FA verification:", error);
      throw error;
    }
  }

  static async verify2FACode(OTP, token) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/admin2FAValidation`,
        { OTP, token }
      );
      return res;
    } catch (error) {
      console.error("Error during 2FA verification:", error);
      throw error;
    }
  }

  static async sendPhoneVerification(phone) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/verification/phone`,
        { phone }
      );
      return res;
    } catch (error) {
      console.error("Error during phone number verification:", error);
      throw error;
    }
  }

  static async verifyOTP(OTP, token) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/user/verification/phone`,
        { OTP, token }
      );
      return res;
    } catch (error) {
      console.error("Error during phone number verification:", error);
      throw error;
    }
  }

  static async forgotPassword(email) {
    try {
      const res = await axios.post(`${this.baseUrl}/api/user/forgot-password`, {
        email,
      });
      return res;
    } catch (error) {
      console.error("Error verification:", error);
      throw error;
    }
  }

  static async forgotPasswordUpdate(newPassword, token) {
    try {
      const res = await axios.post(`${this.baseUrl}/api/user/forgot-password`, {
        newPassword,
        token,
      });
      return res;
    } catch (error) {
      console.error("Error verification:", error);
      throw error;
    }
  }

  // static async updateWallet (jwt, amount) {
  //     const res = await axios.patch(`${this.baseUrl}/api/wallet`,
  //     amount,
  //     {headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${jwt}`, // Include the JWT token
  //       }}
  //     )
  //     return res;
  // }
  static async createTransactionHistory(transactionHistory) {
    const res = await axios.post(
      `${this.baseUrl}/api/transactionHistory`,
      transactionHistory
    );
    return res;
  }
  static async getPaymentHistory(page) {
    const res = await axiosAuth.get(`/api/transactionHistory`, {
      params: {
        page,
      },
    });
    return res;
  }
  static async getBookingTransaction(bookingId) {
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/transactionHistory/bookingTransaction?bookingId=${bookingId}`
      );
      return res;
    } catch (error) {
      console.log("Error in getting booking transaction", error.message);
    }
  }

  static async makeBookingRefund(
    bookingId,
    refundAmount,
    refundMap,
    particular = null,
    isNightChargeCreditRefund = false
  ) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/booking/makeBookingRefund`,
        {
          bookingId: bookingId,
          refundAmount: refundAmount,
          refundMap: refundMap,
          particular: particular,
          isNightChargeCreditRefund: isNightChargeCreditRefund
        }
      );
      // throw new Error("Division by zero is not allowed.");
      return res;
    } catch (error) {
      console.log("Error in making booking refund", error.message);
      throw error;
    }
  }

  static async getTransactionHistoryAdmin(userID, page = 1, pageSize = 10) {
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/transactionHistory/transactionHistoryAdmin?user_id=${userID}&page=${page}&limit=${pageSize}`
      );
      return res;
    } catch (error) {
      console.error("Error fetching booking history:", error.message);
      throw error;
    }
  }

  static async startSession(jwt, session) {
    const res = await axios.post(`${this.baseUrl}/api/sessions`, session, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    });
    return res;
  }
  static async updateWalletCoins(jwt, amount) {
    const res = await axios.post(
      `${this.baseUrl}/api/wallet/updateWallet`,
      { amount: amount },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    return res;
  }

  static async stopSession(edrvSessionID, pauseActionCreatedAt) {
    const res = await axios.get(`${this.baseUrl}/api/sessions`, {
      params: {
        edrvSessionID: edrvSessionID,
        pauseActionCreatedAt: pauseActionCreatedAt,
      },
    });
    return res;
  }

  static async updateSession(
    sessionStartTime,
    sessionEndTime,
    sessionDurationInSeconds,
    averageQuantityPerSec,
    edrvSessionID
  ) {
    const res = await axios.post(
      `${this.baseUrl}/api/sessions/updateSession`,
      {
        sessionStartTime: new Date(sessionStartTime),
        sessionEndTime: new Date(sessionEndTime),
        sessionDurationInSeconds: sessionDurationInSeconds,
        averageQuantityPerSec: averageQuantityPerSec,
        edrvSessionID: edrvSessionID,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  }

  static async endBooking(bookingID, userID, stopActionCreatedAt) {
    const res = await axiosAuth.post(
      `/api/booking/endBooking`,
      {
        bookingID: bookingID,
        userID: userID,
        stopActionCreatedAt: stopActionCreatedAt,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  }

  static async getAmount(jwt) {
    const res = await axiosAuth.get(`/api/wallet/getAmount`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
    });
    return res;
  }

  static async getStripePaymentMethods(jwt, type) {
    const res = await axiosAuth.post(
      `/api/wallet/getStripePaymentmethods`,
      {
        type: type,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );
    return res;
  }

  static async updateBooking(
    bookingId,
    sessionDurationInSeconds,
    paidTime,
    freeTime,
    quantity
  ) {
    const res = await axios.post(
      `${this.baseUrl}/api/booking/updateBooking`,
      {
        bookingId: bookingId,
        totalTime: sessionDurationInSeconds,
        paidTime: paidTime,
        freeTime: freeTime,
        utilizedEnergy: quantity,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  }

  static async rescheduleAllJobs() {
    console.log("inside api fe");
    const res = await axios.get(`${this.baseUrl}/api/scheduler/scheduleAll`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res;
  }

  static async addToWallet(amountInCents, jwt, autoPay, saveCard, pm = "") {
    const res = await axios.post(
      `${this.baseUrl}/api/wallet`,
      {
        //token: result.token.id,
        amount: amountInCents,
        autoPay: autoPay,
        saveCard: saveCard,
        pm: pm,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      }
    );

    return res;
  }

  static async createGuestPaymentHold(amount) {
    const res = await axiosAuth.post(`/api/wallet/guestPaymentHold`, { amount });
    return res;
  }

  static async confirmGuestPaymentHold(paymentIntentId) {
    const res = await axiosAuth.post(`/api/wallet/guestPaymentHoldConfirm`, { paymentIntentId });
    return res;
  }

  static async checkUserInNotificationList(locationId){
    const res = await axiosAuth.get(`api/location/checkUserInNotificationList/${locationId}`);
    return res;
  }

  static async addUserToNotificationList(locationId){
    const res = await axiosAuth.post('api/location/addUserToNotificationList',
      {
        locationId: locationId
      }
    );
    return res;
  }

  static async updateAutoPaySetting(autoPayAmount, autoPay=null) {
    const res = await axiosAuth.post('api/user/updateAutoPay',
      {
        autoPay: autoPay,
        autoPayThreshold: autoPayAmount
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  }
  
  static async getEnergtReport(bookingID) {
    const res = await axios.get(
      `${this.baseUrl}/api/booking/getEnergyReport/${bookingID}`
    );
    return res;
  }

  static async getConfigList() {
    try {
      const res = await axios.get(`${this.baseUrl}/api/config/list`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateConfigs(values) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/config/update`,
        values,
        headers
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getUserGroupsList({ page = 1, limit = 10 }) {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getUserGroupsList`,
        {
          params: {
            page,
            limit,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getUpdatedUserList({
    userGroupId,
    userGroupMembers,
    page = 1,
    limit = 10,
    filterEmail,
    filterFirstName,
    filterLastName,
    filterContact,
  }) {
    try {
      const response = await axiosAuth.post(
        `${this.baseUrl}/api/userGroup/getUpdatedUserList`,
        {
          params: {
            userGroupId,
            userGroupMembers,
            page,
            limit,
            filterEmail,
            filterContact,
            filterFirstName,
            filterLastName,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getUserGroupMembersList({
    userGroupId,
    page,
    limit,
    filterEmail,
    filterFirstName,
    filterLastName,
    filterContact,
  }) {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getUserGroupMembersList`,
        {
          params: {
            userGroupId,
            page,
            limit,
            filterEmail,
            filterContact,
            filterFirstName,
            filterLastName,
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getUserPermissionsList({ userGroupId, page, limit }) {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getPermissionsList`,
        {
          params: { userGroupId, page, limit },
        }
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async getAllUserPermissionsList() {
    try {
      const response = await axiosAuth.get(
        `${this.baseUrl}/api/userGroup/getAllPermissionsList`
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async createUserGroup(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/createUserGroups`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async createPermission(permission) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/permission/createPermission`,
        permission,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async updatePermission(permission) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosAuth.post(
        `${this.baseUrl}/api/permission/updatePermission`,
        permission,
        headers
      );
      return response;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }
  static async deletePermission(permission) {
    const headers = {
      "Content-Type": "application/json",
    };
    const response = await axiosAuth.post(
      `${this.baseUrl}/api/permission/deletePermission`,
      permission,
      headers
    );
    return response;
  }

  static async updateUserGroup(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/updateUserGroup`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async deleteUserGroup(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/deleteUserGroup`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async deleteUserGroupMembers(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/deleteUserGroupMembers`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async addUserGroupMembers(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/addUserGroupMembers`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }

  static async updateUserGroupMembers(userGroup) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const res = await axios.post(
        `${this.baseUrl}/api/userGroup/updateUserGroupMembers`,
        userGroup,
        headers
      );
      return res;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }
// startDate, endDate, locationId, environment
  static async getLocationSessionReportLambda(startDate = null, endDate = null, locationID = null){ 
    let environment = null;
    try {
      environment = this.environment;
      console.log(environment)
    } catch (err) {
      console.log("Error in getting env", err.message);
    }try {
      // console.log('AWS URL: ',this.awsUrl);
      // console.log("selectedManufacturers", selectedManufacturers)
      const res = await axios.get(`${this.awsUrl}/customer-session-report`, {
        params: {
          locationId: locationID,
          startDate: startDate,
          endDate: endDate,
          environment: environment,
        },
      });
      return res;
    } catch (error) {
      console.log(
        "Error in retrieval of AWS Lambda Data regarding CSV file generation for location session report:",
        error.message
      );
    }
  }

  static async getLambdaData(
    startDate = null,
    endDate = null,
    locationID = null,
    selectedManufacturers = null,
    callFrom = null //  Customer
  ) {
    console.log("call params : ", startDate, endDate, locationID, selectedManufacturers, callFrom)
    let environment = null;
    try {
      environment = this.environment;
      // console.log(environment)
    } catch (err) {
      console.log("Error in getting env", err.message);
    }
    try {
      // console.log('AWS URL: ',this.awsUrl);
      // console.log("selectedManufacturers", selectedManufacturers)
      const res = await axios.get(`${this.awsUrl}/csv`, {
        params: {
          locationID: locationID,
          startDate: startDate,
          endDate: endDate,
          environment: environment,
          selectedManufacturers: encodeURIComponent(
            JSON.stringify(selectedManufacturers)
          ),
          callFrom: callFrom,
        },
      });
      return res;
    } catch (error) {
      console.log(
        "Error in retrieval of AWS Lambda Data regarding CSV file generation:",
        error.response
      );
    }
  }

  static async getDowntimeLambdaData(
    startDate = null,
    endDate = null,
    selectedChargers = null
  ) {
    let environment = null;
    try {
      environment = this.environment;
      // console.log(environment)
    } catch (err) {
      console.log("Error in getting env", err.message);
    }
    try {
      // console.log('AWS URL: ',this.awsUrl);
      // console.log("selectedManufacturers", selectedChargers)
      // console.log(startDate);
      // console.log(endDate);
      // console.log(selectedChargers);
      // console.log(environment);

      const res = await axios.get(`${this.awsUrl}/DowntimeCSVFileDownload`, {
        params: {
          startDate: startDate,
          endDate: endDate,
          locationChargers: encodeURIComponent(
            JSON.stringify(selectedChargers)
          ),
          environment: environment,
        },
      });
      // const res = await axios.get(`${this.awsLambdaUrl}/DowntimeCSVFileDownload`,{params:{startDate:"2024-12-08T00:00:00.000Z",endDate:"2024-12-15T23:59:59.999Z",locationChargers:"%5B%22672cca1f8caa5f9fb4e51e78%22%5D",environment:"PROD"}});

      return res;
    } catch (error) {
      console.log(
        "Error in retrieval of AWS Lambda Data regargding CSV file generation:",
        error.response
      );
    }
  }

  static async getDashboardFilterLocations() {
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/dashboardFilterLocations`,
        {}
      );
      return res;
    } catch (error) {
      console.log(
        "Error in retrieval of dashboard filter locations:",
        error.response
      );
    }
  }

  static async getDashboardData(
    startDate = null,
    endDate = null,
    locationID = null
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);

    try {
      const res = await axios.get(`${this.baseUrl}/api/dashboard/getData`, {
        params: {
          locationID: locationID,
          startDate: startDate,
          endDate: endDate,
        },
      });
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDayOfWeekUtilizationData(
    startDate = null,
    endDate = null,
    locationID = null
  ) {
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDayOfWeekUtilization`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
            timezone: timezone,
            StartUTCOffset: StartUTCOffset,
            EndUTCOffset: EndUTCOffset,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }




  static async getMonthlyCreditRevenuePerUser(
    startDate = null,
    endDate = null,
    
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);
    // console.log("dates before update: ", startDate, endDate)
    // let UTCOffset = new Date().getTimezoneOffset();
    // console.log("UTC Offset: ", UTCOffset)
    // console.log("Selected Timezone: ", selectedTimezone)
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    // console.log("dates after update: ", startDate, endDate)

  
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getMonthlyCreditRevenuePerUser`,
        {
          params: {
            
            startDate: startDate,
            endDate: endDate,
            
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }













  static async getDashboardRevenueData(
    startDate = null,
    endDate = null,
    locationID = null,
    selectedTimezone
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);
    // console.log("dates before update: ", startDate, endDate)
    // let UTCOffset = new Date().getTimezoneOffset();
    // console.log("UTC Offset: ", UTCOffset)
    // console.log("Selected Timezone: ", selectedTimezone)
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    // console.log("dates after update: ", startDate, endDate)

    let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardRevenueData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
            selectedTimezone: selectedTimezone,
            StartUTCOffset: StartUTCOffset,
            EndUTCOffset: EndUTCOffset,
            timezone: timezone,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }
  static async getChargerCount(locationID = null) {
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getChargerCount`,
        { params: { locationID: locationID } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardEnergyConsumptionData(
    startDate = null,
    endDate = null,
    locationID = null,
    selectedTimezone
  ) {
    // let UTCOffset = new Date().getTimezoneOffset();
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    //    console.log("dates after update: ", startDate, endDate)
    let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardEnergyConsumptionData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
            selectedTimezone: selectedTimezone,
            StartUTCOffset: StartUTCOffset,
            EndUTCOffset: EndUTCOffset,
            timezone: timezone,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardUtilizationData(
    startDate = null,
    endDate = null,
    locationID = null,
    selectedTimeZone
  ) {
    // console.log("selectedTimeZone in dashboard api: ", selectedTimeZone)
    // console.log("start date; ", startDate)
    // console.log("end date: ", endDate)
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);

    // let filterEndDate = endDate ? endDate : new Date()
    // let currentDate = new Date()
    // let filterStartDate = startDate ? startDate : new Date(currentDate.setMonth(currentDate.getMonth() - 6))
    if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardUtilizationData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
            StartUTCOffset: StartUTCOffset,
            EndUTCOffset: EndUTCOffset,
            selectedTimeZone: selectedTimeZone,
            timezone: timezone,
          },
        }
      );
      // console.log(res)
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardBookingDurationData(
    startDate = null,
    endDate = null,
    locationID = null
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardBookingDurationData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardUsersData(
    startDate = null,
    endDate = null,
    locationID = null
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardUsersData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardAverageChargingSpeed(
    startDate = null,
    endDate = null,
    locationId = null,
    selectedTimezone
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationId, startDate, endDate);
   if (endDate == null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate == null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    } 
    try {
    // console.log(startDate, endDate)
      let EndUTCOffset = endDate.getTimezoneOffset();
    let StartUTCOffset = startDate.getTimezoneOffset();
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardAverageChargingSpeed`,
        {
          params: {
            locationId: locationId,
            startDate: startDate,
            endDate: endDate,
            selectedTimezone: selectedTimezone,
            StartUTCOffset: StartUTCOffset,
            EndUTCOffset: EndUTCOffset,
            timezone: timezone,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard average charging speed data:", error);
    }
  }


  static async getDashboardDayUtilizationData(
    startDate = null,
    endDate = null,
    locationID = null,
    analytics = ""
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);
    let UTCOffset = new Date().getTimezoneOffset();
    let filterEndDate = endDate ? endDate : new Date();
    let currentDate = new Date();
    let filterStartDate = startDate
      ? startDate
      : new Date(currentDate.setMonth(currentDate.getMonth() - 6));

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardDayUtilizationData`,
        {
          params: {
            locationID: locationID,
            startDate: new Date(filterStartDate).setHours(0, 0, 0, 0),
            endDate: new Date(filterEndDate).setHours(23, 59, 59, 999),
            UTCOffset: UTCOffset,
            analytics: analytics,
          },
        }
      );
      // console.log(res)
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardUptimeData(
    startDate = null,
    endDate = null,
    locationID = null
  ) {
    // console.log('Logging inside breathe api dashboard function: ',locationID, startDate, endDate);

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardUptimeData`,
        {
          params: {
            locationID: locationID,
            startDate: startDate,
            endDate: endDate,
          },
        }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardAdminCredits(startDate = null, endDate = null) {
    if (endDate === null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate === null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }
    //    let UTCOffset = new Date().getTimezoneOffset();
    //    console.log('start date admin credits: ',UTCOffset);
    //    console.log('start date admin credits: ',startDate);
    //    console.log('end date: admin credits',endDate);

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardAdminCredits`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardRegisteredUsersData(
    startDate = null,
    endDate = null
  ) {
    if (endDate === null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate === null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardRegisteredUsersData`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardTotalRegisteredUsers(
    startDate = null,
    endDate = null
  ) {
    if (endDate === null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate === null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardTotalRegisteredUsers`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getUsersRegisteredButNeverCharged(
    startDate = null,
    endDate = null
  ) {
    try {
      if (endDate === null) {
        endDate = new Date(new Date().setHours(23, 59, 59, 999));
        // endDate = current Date
      }
      if (startDate === null) {
        let initalStart = new Date(endDate.getTime());
        startDate = new Date(
          new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
            0,
            0,
            0,
            0
          )
        );
        // endDate - 6 months
      }

      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getUsersRegisteredButNeverCharged`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardActiveUsers(startDate = null, endDate = null) {
    if (endDate === null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate === null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardActiveUsers`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async getDashboardSecondaryActiveUsers(
    startDate = null,
    endDate = null
  ) {
    if (endDate === null) {
      endDate = new Date(new Date().setHours(23, 59, 59, 999));
      // endDate = current Date
    }
    if (startDate === null) {
      let initalStart = new Date(endDate.getTime());
      startDate = new Date(
        new Date(initalStart.setMonth(initalStart.getMonth() - 6)).setHours(
          0,
          0,
          0,
          0
        )
      );
      // endDate - 6 months
    }

    try {
      const res = await axios.get(
        `${this.baseUrl}/api/dashboard/getDashboardSecondaryActiveUsers`,
        { params: { startDate: startDate, endDate: endDate } }
      );
      return res;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
    }
  }

  static async checkBookingExist(charger, startTime, endTime) {
    try {
      const res = await axios.post(
        `${this.baseUrl}/api/booking/checkBookingExist`,
        {
          charger,
          startTime,
          endTime,
        }
      );
      return res.data;
    } catch (error) {
      console.log("Error in retrieval of dashboard data:", error.response);
      return null;
    }
  }

  static async getCouponCodeList({ page = 1, limit = 10 }) {
    try {
      const params = {
        page,
        limit,
      };

      const res = await axios.get(`${this.baseUrl}/api/coupons/list`, {
        params: params,
      });

      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createCoupon(couponData) {
    try {
      const res = await axiosAuth.post(`/api/coupons/add`, couponData);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async editCoupon(couponId, updatedData) {
    try {
      const res = await axiosAuth.put(
        `/api/coupons/edit/${couponId}`,
        updatedData
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async deleteCouponCode(couponID) {
    try {
      const res = await axiosAuth.delete(`/api/coupons/delete/${couponID}`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async checkCouponValidWithLocation(couponCode, locationId) {
    const res = await axiosAuth.post(
      `/api/coupons/checkCouponValidWithLocation`,
      {
        locationId,
        couponCode,
      }
    );
    return res;
  }

  static async getActiveStates() {
    try {
      const res = await axios.get(
        `${this.baseUrl}/api/location/getActiveStates`
      );
      return res;
    } catch (error) {
      console.log("Error fetching active states information ", error.message);
      throw error;
    }
  }

  static async getStateLevelDataReport(
    filterFromDate,
    filterToDate,
    selectedStates
  ) {
    let environment = this.environment;
    try {
      const res = await axios.get(`${this.awsUrl}/stateLevelDataReport`, {
        params: {
          startDate: filterFromDate,
          endDate: filterToDate,
          selectedStates: encodeURIComponent(JSON.stringify(selectedStates)),
          environment: environment,
        },
      });
      return res;
    } catch (error) {
      console.log("Error fetching state level date report ", error.message);
      throw error;
    }
  }

  static async sendEmail({recipients,emailSubject,emailBody,selectAllUsers,location}){
    try {
      
      const res = await axios.post(`${this.baseUrl}/api/user/sendEmail`, 
       {
          recipients:recipients,
          emailSubject:emailSubject,
          emailBody:emailBody,
          selectAllUsers:selectAllUsers,
          location:location
        },
    )

      return res;
      
    } catch (error) {
      console.log('Error while sending email to user: ',error)
      
    }

  }
  static async getPublicUsers({page,limit,filterText, locationId}){
    try {
      
      const res = await axios.get(`${this.baseUrl}/api/user/getPublicUsers`, 
     {  params:{  
        page:page,
        limit:limit,
        filterText: filterText,
          locationId:locationId
        }},
    )

      return res;
      
    } catch (error) {
      console.log('Error while sending email to user: ',error)
      
    }

  }

  static async getCurrentDayUserBookings(startOfDay, endOfDay){
    const res = await axiosAuth.get(`/api/booking/getCurrentDayUserBookings`, {
        params: {startOfDay: startOfDay, 
        endOfDay: endOfDay}
    })
    return res 
  }

  // ── Message Templates ──────────────────────────────────────────────────────
  static async getMessageTemplateList({ channel } = {}) {
    try {
      const params = {};
      if (channel) params.channel = channel;
      const res = await axiosAuth.get(`/api/messageTemplates/list`, { params });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async getMessageTemplateById(id) {
    try {
      const res = await axiosAuth.get(`/api/messageTemplates/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createMessageTemplate(data) {
    try {
      const res = await axiosAuth.post(`/api/messageTemplates/create`, data);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateMessageTemplate(id, data) {
    try {
      const res = await axiosAuth.put(`/api/messageTemplates/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async deleteMessageTemplate(id) {
    try {
      const res = await axiosAuth.delete(`/api/messageTemplates/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async sendMessageTemplate(id, data) {
    try {
      const res = await axiosAuth.post(`/api/messageTemplates/${id}/send`, data);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async manualBillBooking(bookingId, energyVal){
    const res = await axiosAuth.post(`/api/booking/manualBillBooking`, {
      bookingId: bookingId,
      energyVal: energyVal
    })
    return res;
  }
  static async updateCostToHubspot(data){
    const res = await axiosAuth.post(`/api/deals/updateCostToHubspot`, {
      data
    })
    return res
  }
  // ── End Message Templates ──────────────────────────────────────────────────

  // ── User Guide ─────────────────────────────────────────────────────────────
  static async getUserGuideList() {
    try {
      const res = await axiosAuth.get(`/api/userGuide/list`);
      return res;
    } catch (error) {
      throw error;
    }
  }

  // Uploads a guide image or MP4 video; onProgress(percent) is optional
  static async uploadUserGuideImage(file, onProgress) {
    try {
      const formData = new FormData();
      formData.append('image', file);
      const res = await axiosAuth.post(`/api/userGuide/uploadImage`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async discardUserGuideImages(keys) {
    try {
      const res = await axiosAuth.post(`/api/userGuide/discardImages`, { keys });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async createUserGuidePage(data) {
    try {
      const res = await axiosAuth.post(`/api/userGuide/create`, data);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async updateUserGuidePage(id, data) {
    try {
      const res = await axiosAuth.put(`/api/userGuide/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async reorderUserGuidePages(ids) {
    try {
      const res = await axiosAuth.put(`/api/userGuide/reorder`, { ids });
      return res;
    } catch (error) {
      throw error;
    }
  }

  static async deleteUserGuidePage(id) {
    try {
      const res = await axiosAuth.delete(`/api/userGuide/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  }
  // ── End User Guide ─────────────────────────────────────────────────────────

  // static async getLambdaData(startDate=null,endDate=null,locationID=null,selectedManufacturers=null){
  //     let environment = null
  //     try{
  //         environment = this.environment
  //         console.log(environment)
  //     }
  //     catch(err){
  //         console.log("Error in getting env",err.message)
  //     }
  //     try {
  //         console.log('AWS URL: ',this.awsUrl);
  //         console.log("selectedManufacturers", selectedManufacturers)
  //         const res = await axios.get(`${this.awsUrl}`,{params:{locationID: locationID,startDate:startDate,endDate:endDate,environment:environment,selectedManufacturers:encodeURIComponent(JSON.stringify(selectedManufacturers))}});
  //         return res;

  //     } catch (error) {
  //         console.log("Error in retrieval of AWS Lambda Data regargding CSV file generation:",error.response);

  //     }
  // }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // static async getFutureEstimate(jwt){
  //     const res = await axios.get(`${this.baseUrl}/api/user/getFutureEstimate`,{
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${jwt}`
  //         }
  //       });

  //     return res;
  // }
}

// static async registerUser(userData){
//     const res = await axios.post("/api/user",{
//         method:'POST',

//         headers:{'Content-Type':'application/json'
//         },
//         body: JSON.stringify(userData)
//       }
//     )
//     return res;
// }
// }
